module.exports = __webpack_public_path__ + "img/diet-1.03a36ffb.jpg";